import react from "react";
import ReactDOM from "react-dom";
import * as ReactBootstrap from "react-bootstrap";

window.React = react;
window.ReactDOM = ReactDOM;
window.ReactBootstrap = ReactBootstrap;
